import { Typography } from "@lyfegen-platform/react-common";
import { Box, IconButton } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useMessagesStyles from "./use-messages-styles";
import formatMessageContent from "./utils/format-message-content";

interface MessageContentProps {
	content: string;
}

const CaseMessageContent: React.FC<MessageContentProps> = ({ content }) => {
	const { contentContainer, readMoreText, smallFont } = useMessagesStyles();
	const { t } = useTranslation();
	const defaultContentLength = 138;

	const [readMore, setReadMore] = useState(defaultContentLength);

	const isDefaultContent = readMore === defaultContentLength;

	const handleClick = () => {
		if (isDefaultContent) {
			setReadMore(content.length);
		} else {
			setReadMore(defaultContentLength);
		}
	};

	const buttonContent = isDefaultContent ? t("read-more").toUpperCase() : t("hide").toUpperCase();

	return (
		<Box className={contentContainer}>
			<Box>
				{content?.length <= readMore ? formatMessageContent(content) : formatMessageContent(content.substring(0, readMore - 35))}
				{content?.length > defaultContentLength && (
					<IconButton
						disableRipple
						onClick={handleClick}
						classes={{
							root: readMoreText,
						}}
					>
						<Typography classes={{ root: smallFont }}>...{buttonContent}</Typography>
					</IconButton>
				)}
			</Box>
		</Box>
	);
};

export default CaseMessageContent;
